export default __webpack_public_path__ + "static/media/3.74b8ca17.png";